var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/thumb_navigation-link.tsx";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.some.js";
import classNames from 'classnames';
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import IconWithCounter from 'soapbox/components/icon_with_counter';
import { Icon } from 'soapbox/components/ui';
const ThumbNavigationLink = ({
  count,
  src,
  text,
  to,
  exact,
  paths,
  onClick,
  active,
  className
}) => {
  const {
    pathname
  } = useLocation();
  const isActive = () => {
    if (active) return active;
    if (paths) {
      return paths.some(path => pathname.startsWith(path));
    } else {
      return exact ? pathname === to : pathname.startsWith(to);
    }
  };
  const internalActive = isActive();
  const Wrapper = React.useMemo(() => ({
    children
  }) => to ? /*#__PURE__*/React.createElement(NavLink, {
    to: to,
    exact: exact,
    className: `${className} px-2 py-2.5 space-y-1 flex flex-col flex-1 items-center text-gray-600`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 62
    }
  }, children) : /*#__PURE__*/React.createElement("button", {
    className: `${className} px-2 py-2.5 space-y-1 flex flex-col flex-1 items-center text-gray-600`,
    onClick: onClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 215
    }
  }, children), [to, onClick, exact]);
  return /*#__PURE__*/React.createElement(Wrapper, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 5
    }
  }, count !== undefined ? /*#__PURE__*/React.createElement(IconWithCounter, {
    src: src,
    className: classNames({
      'h-5 w-5': true,
      'text-gray-600 dark:text-gray-300': !internalActive,
      'text-primary-600': internalActive
    }),
    count: count,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 9
    }
  }) : /*#__PURE__*/React.createElement(Icon, {
    src: src,
    className: classNames({
      'h-5 w-5': true,
      'text-gray-600 dark:text-gray-300': !internalActive,
      'text-primary-600': internalActive
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-[0.7rem] text-gray-900 dark:text-gray-100 font-normal tracking-normal font-sans normal-case",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 7
    }
  }, text));
};
export default ThumbNavigationLink;